import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Provider.UploadLogo.IRequest;
type Response = Api.Core.Provider.UploadLogo.IResponse;
type Headers = Api.Core.Provider.UploadLogo.IHeaders;
const apiPath = '/api/ProductManagement/Provider/:id/Logo';
export default async function providerUploadLogoApi(id: number, request: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiPath, { id }),
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
}
